import React from "react";
import ReactDOM from "react-dom/client";

//import "bootstrap/dist/css/bootstrap.css"; -- same bootstrap
import "./bootstrap-custom.scss"; // bootstrap replaced by this
import "bootstrap-icons/font/bootstrap-icons.css";

// import 'bootstrap/dist/css/bootstrap.min.css'; -- same bootstrap
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "boxicons/css/boxicons.min.css";
import "remixicon/fonts/remixicon.css";
import "@phosphor-icons/web/regular";
import "@phosphor-icons/web/light";

import "glightbox/dist/css/glightbox.min.css";

import "./index.css";

import App from "./App";

import reportWebVitals from "./reportWebVitals";

import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Dropzone from "dropzone";

// import { Tooltip } from "bootstrap";
// new Tooltip(document.createElement("div"));

Dropzone.autoDiscover = false;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
